import React from "react";
import {Outlet, useSearchParams} from "react-router-dom";
import {useAppDispatch, store} from "../../redux/store";
import {
  clearAuthState,
  updateHeaderDetails,
} from "../../redux/reducers/authSlice";
import {switchApplication} from "commonUtils/switchApplication";
import {postRequest, setHeader} from "repository/genericRepository";
import {HEADER_INFORMATION_ENDPOINT} from "commonUtils/globalAPISettings";
import {isValidObject, loggedMessage} from "commonUtils/utils";
import {
  AxiosErrorCode,
  HttpStatusCode,
  PageNames,
} from "commonUtils/enumerations";
import {
  HttpException,
  ServiceAuthenticationException,
} from "services/exceptionHandlerService";

// project imports

// ==============================|| ANONYMOUS LAYOUT ||============================== //

const AnonymousLayout: React.FC = () => {
  const [params, setParams] = React.useState<boolean>(false);
  const dispatch = useAppDispatch();
  const [searchParam, setSearchParam] = useSearchParams();
  const searchParams = new URLSearchParams(window.location.search);
  if (
    searchParams.has("userIdentity") &&
    searchParams.has("userId") &&
    !params
  ) {
    setParams(true);
    dispatch(clearAuthState());
    switchApplication(window.location.search, window.location.pathname);
  }

  React.useEffect(() => {
    try {
      if (searchParam.has("userIdentity")) {
        searchParam.delete("userIdentity");
      }
      if (searchParam.has("userId")) {
        searchParam.delete("userId");
      }
      if (searchParam.has("profileId")) {
        searchParam.delete("profileId");
      }
      if (searchParam.has("userName")) {
        searchParam.delete("userName");
      }
      if (searchParam.has("switchedUserId")) {
        searchParam.delete("switchedUserId");
      }
      if (searchParam.has("switchedProfileId")) {
        searchParam.delete("switchedProfileId");
      }
      if (searchParam.has("switchedUserName")) {
        searchParam.delete("switchedUserName");
      }
      if (searchParam.has("token")) {
        searchParam.delete("token");
      }
      if (searchParam.has("llyReadOnlyUser")) {
        searchParam.delete("llyReadOnlyUser");
      }
      if (searchParam.has("supplierId")) {
        searchParam.delete("supplierId");
      }
      if (searchParam.has("userTypeId")) {
        searchParam.delete("userTypeId");
      }
      setSearchParam(searchParam, {replace: true});
      loadHeaderDetails();
    } catch (error: any) {
      loggedMessage(error, "", PageNames.DASHBOARD);
    }
  }, []);

  const loadHeaderDetails = async () => {
    try {
      const authState = store.getState();
      if (
        authState?.auth?.authDetails?.isAuthenticated &&
        (authState?.auth?.userDetails?.pageToLoad.toLowerCase() ===
          "userprofile" ||
          authState?.auth?.userDetails?.pageToLoad.toLowerCase() === "")
      ) {
        const APIHeaders = {
          Authorization: `Bearer ${authState?.auth?.authDetails?.token}`,
        };
        let switchedProfileId = authState?.auth?.userDetails?.switchedProfileId;
        let userId = authState?.auth?.userDetails?.userId;
        let profileId = authState?.auth?.userDetails?.profileId;
        let userName = authState?.auth?.userDetails?.userName;
        if (switchedProfileId <= 0) {
          switchedProfileId = profileId <= 0 ? userId : profileId;
          profileId = userId = 0;
          userName = "";
        }
        const responseData = await postRequest({
          url: HEADER_INFORMATION_ENDPOINT,
          headers: setHeader(APIHeaders),
          params: {switchedProfileId, userId, profileId, userName},
          data: {},
        });
        if (isValidObject(responseData)) {
          const payLoad = {
            isJumpToVisible: responseData.isJumpToVisible,
            frJumpTo: responseData.frJumpTo,
            cppJumpTo: responseData.cppJumpTo,
            userList: responseData.userList,
            cpsUserProfiles: responseData.cpsUserProfiles,
            showTrainingPopUp: responseData.showTrainingPopUp,
          };
          dispatch(updateHeaderDetails(payLoad));
        }
      }
    } catch (error: any) {
      loggedMessage(error, "", PageNames.DASHBOARD);
      handleAxiosErrors(error);
    }
  };

  const handleAxiosErrors = (error: any) => {
    const data = {pagename: PageNames.USERPROFILE};
    if (error?.code === AxiosErrorCode.ERR_BAD_REQUEST) {
      if (
        error?.response?.status === HttpStatusCode.UNAUTHORIZED ||
        error?.response?.status === HttpStatusCode.FORBIDDEN
      ) {
        ServiceAuthenticationException(error, data, error?.response?.status);
      } else if (error?.response?.status === HttpStatusCode.BAD_REQUEST) {
        // setErrorMsg(error.response.data.message);
      } else if (error?.response?.status === HttpStatusCode.NOT_FOUND) {
        // setErrorMsg(CPSConstants.SERVICE_NOT_FOUND);
      } else if (
        error?.response?.status === HttpStatusCode.INTERNAL_SERVER_ERROR
      ) {
        HttpException(error, data);
        // setErrorMsg(CPSConstants.INTERNAL_SERVER_ERROR);
      } else {
        // setErrorMsg(error.message);
      }
    } else if (error?.code === AxiosErrorCode.ECONNABORTED) {
      // setErrorMsg(CPSConstants.TIMEOUT_ERROR);
    } else if (error?.code === AxiosErrorCode.ERR_NETWORK) {
      // setErrorMsg(CPSConstants.NETWORK_ERROR);
    } else {
      // setErrorMsg(error.message);
    }
  };

  return (
    <>
      <Outlet />
    </>
  );
};

export default AnonymousLayout;
